import React, { FunctionComponent } from 'react';
import { Platform } from 'react-native';
import { SvgComponentProps } from './Svg.types'


export const SvgComponent: FunctionComponent<SvgComponentProps> = ({
  svgFile: SvgFile,
  height = 24,
  width,
  fill,
  color
}) => {
  if (Platform.OS === 'web') {
    const style: any = {};
    
    // Seulement appliquer des styles si fill ou color sont définis
    if (fill === '#fff' || color === '#fff') {
      style.filter = 'brightness(0) invert(1)';
    } else if (fill) {
      style.color = fill;
    } else if (color) {
      style.color = color;
    } else {
      style.color = 'black';
    }
    
    return <img src={SvgFile as string} width={width || height} height={height} alt={'SVG'} style={style} />;
  }
  
  // Pour React Native, construire les props conditionnellement
  const svgProps: any = {
    height,
    width: width || height,
    fill: fill || 'white', // Couleur par défaut
    stroke: color || 'null' // Couleur par défaut pour stroke
  };
  
  return <SvgFile {...svgProps} />;
};